export const BLOCKCHAIN_NAMES: Record<string, string> = {
	ETH: "Ethereum",
	MATIC: "Polygon",
	POLYGON: "Polygon",
	BSC: "BSC",
	TRON: "TRON",
	BTC: "Bitcoin",
};
